import React from 'react';
import { useSelector } from 'react-redux';

import { TrackingTimeLine } from './tracking-list.component';

import { getTrackingList } from '../../entities/tracking/selectors';

export const TrackingList = () => {
  const list = useSelector(getTrackingList);

  return <TrackingTimeLine list={list} />;
};
